import { Component, HostBinding, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PublicSurveyService } from './public-survey.service';
import { IBlankslateOptions } from '@mono-repo/ui';
import { TranslateService } from '@mono-repo/util';
import { ICoreSurveyAnswer, IDynamicLayout } from '@mono-repo/data';
import { MessageService } from '@mono-repo/messages';

@Component({
  selector: 'dt-public-survey',
  templateUrl: './public-survey.component.html',
})
export class PublicSurveyComponent implements OnInit {
  @HostBinding('class') public class = 'dt-l-public-survey';
  private translateService = inject(TranslateService);
  private route = inject(ActivatedRoute);
  private publicSurveyService = inject(PublicSurveyService);
  private messageService = inject(MessageService);

  public survey: IDynamicLayout;
  private paramId: string;
  public blankslateOptions: IBlankslateOptions = {
    heading: this.translateService.translate('NO_DATA'),
    text: this.translateService.translate('NO_DATA_TEXT'),
    icon: ' ui-icon-expected',
  };

  ngOnInit(): void {
    this.translateService.setCurrentModuleTranslation('public_survey');
    this.paramId = this.route.snapshot.paramMap.get('surveyId');

    this.publicSurveyService.getPublicSurveyById(this.paramId).subscribe({
      next: (response) => {
        this.survey = response;
      },
      error: (err) => {
        throw new Error('Error fetching public survey: ' + err.message);
      },
    });
  }

  public onSubmit(answerQuestionFields: ICoreSurveyAnswer[]): void {
    this.publicSurveyService.submitPublicSurvey(this.paramId, answerQuestionFields).subscribe({
      next: () => {
        this.messageService.add(this.translateService.translate('TENANT_SURVEY_SUBMISSION_SUCCESS_MESSAGE'), 'success');
      },
      error: (err) => {
        throw new Error('Error submitting public survey: ' + err.message);
      },
    });
  }
}
